/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import AWSAppSyncClient from 'aws-appsync';
import { DocumentNode } from 'graphql';
import { gql } from 'graphql-tag';
import { filter, map } from 'rxjs/operators';
import {
  ReceiveAckResponse,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';
import { isNotNullOrUndefined } from '../../utils';

export interface OnReceiveAckInput {
  deviceId?: string;
}
const build = (_query: DocumentNode, input: OnReceiveAckInput, name = 'QueryResult') => {
  const bQuery = `
  subscription ${ name }(`+
    ( input.deviceId !== undefined ? `$deviceId: String = ${JSON.stringify(input.deviceId).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    onReceiveAck(
      ${ input.deviceId !== undefined ? 'deviceId: $deviceId,' : '' }
    ){
      ...receiveackresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class OnReceiveAckSubscription {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment receiveackresponse on ReceiveAckResponse { ... }
   */
  execute(_query: DocumentNode, input: OnReceiveAckInput) {
    return this.graphqlClient$.pipe(
      isNotNullOrUndefined(),
      map((client: AWSAppSyncClient<any>) =>
        client.subscribe<{ data : {  onReceiveAck : Partial<ReceiveAckResponse>} }>({ query: build(_query, input) }),
      ),
    );
  }
}
